<template>
  <div>
    <li>
      <strong class="plan-renew-title">Plan Renewal Options:</strong>
      <div class="col-md-5 m-2 ">
        <b-form-select
            v-model="selectedPlan"
            :options="dropdownOptions"
            :disabled="isLoading"
        >
        </b-form-select>
      </div>
      <!--    <multiselect
              :placeholder="placeholder"
              v-model="selectedPlan"
              label="formatted_plan_name"
              track-by="pid"
              :options="plans"
              :internal-search="false"
              :close-on-select="true"
              :clear-on-select="false"
              @search-change="searchHandler"
              @open="openPlans"
          >
          </multiselect>-->
      <a
          href="javascript:void(0);"
          v-if="selectedPlan"
          v-b-modal.alert-popup2
          class="notice-btn plan-renew-btn"
      >
        Change Plan
      </a>
      <dashboard-enrollment-renew-plan-modal
          v-if="selectedPlan"
          @checkRenewalStatus="checkRenewalStatus"
          :current-plan="currentPlan"
          :new-plan.sync="selectedPlan"
      />
    </li>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import DashboardEnrollmentRenewPlanModal from "./DashboardEnrollmentRenewPlanModal.vue";

export default {
  components: { DashboardEnrollmentRenewPlanModal },
  name: "DashboardEnrollmentRenewPlan",
  props: {
    currentPlan: {
      required: true,
      type: Object,
    },
    member: {
      required: true,
      type: Object,
    }
  },
  data: () => ({
    selectedPlan: null,
    plans: [],
    renewalPlanList: [],
    placeholder: "Choose renewal plans",
    isLoading: false,
    isPlanSwitchable: true
  }),
  computed: {
    dropdownOptions() {
      if (this.isLoading) {
        return [{ text: "Loading...", value: null }];
      }
      return [{ text: this.placeholder, value: null }, ...this.renewalPlanList];
    },
  },
  methods: {
/*    openPlans() {
      this.placeholder = "Loading plans..";
      this.getMajorMedicalPlans();
    },
    searchHandler(query) {
      if (query.length > 3) {
        this.getMajorMedicalPlans(query);
      }
    },*/
    getMajorMedicalPlans(query) {
      this.isLoading = true;
      let url = `v2/get-major-medical-plans/${this.member.user_id}`;
      if (query) {
        url = `${url}?query=${query}`;
      }
      Api.get(url)
          .then((res) => {
            this.plans = res.data.data;
            this.renewalPlanList = this.plans.map((plan) => ({
              value: plan,
              text: plan.formatted_plan_name,
            }));
            this.isLoading = false;
          })
          .catch(() => {
            this.plans = [];
            this.isLoading = false;
          });
    },
    checkRenewalStatus() {
      // this.isLoading = true;
      // let url = `v2/check-if-plan-switchable/${this.member.user_id}`;
      // Api.get(url)
      //     .then((res) => {
      //       this.isLoading = false;
            this.isPlanSwitchable = true;
          // })
          // .catch(() => {
          //   this.plans = [];
          //   this.isLoading = false;
          // });
    },
  },
  created() {
    this.getMajorMedicalPlans();
    // this.checkRenewalStatus()
  },
};
</script>
<style scoped>
.plan-renew-title,
.plan-renew-btn {
  margin-top: 11px;
}
.plan-renew-btn{
  padding: 0.4rem 0.8rem;
  border-radius: 6px;
  background-color: #29bcff;
  color: #fff;
  height:max-content;
  margin-top: 8px;
}
.plan-renew-btn:hover{
  background-color: #1a9ebf;
}
</style>